export var isValidSearch = function isValidSearch(query) {
  return query.length;
};